import t from '@jetshop/intl';
import { Above, Below } from '@jetshop/ui/Breakpoints';
import Drawer, { DrawerTarget, DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
// import SortOrderDropdown from '@jetshop/ui/SortOrder/SortOrderDropdown';
import SortOrderDropdown from './SortOrderDropdown';
import { ReactComponent as Carrot } from '@jetshop/ui/svg/Carrot.svg';
import { styled } from 'linaria/react';
import get from 'lodash.get';
import React, { Component } from 'react';
import { theme } from '../../Theme';
import { ActiveFilters } from './ActiveFilters';
import { BooleanFilters } from './BooleanFilters';
import FilterDrawer from './FilterDrawer';
import { ListFilters } from './ListFilters';
import { MultiListFilters } from './MultiListFilters';
import { RangeFilters } from './RangeFilters';

const ButtonWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  margin-bottom: ${theme.space[3]};
  button:first-of-type {
    margin-right: ${theme.space[1]};
  }
  ${theme.above.sm} {
    padding: ${theme.space[1]};
  }
  svg {
    transform: rotate(-90deg);
  }
`;

const MobileButton = styled('button')`
  height: 40px;
  background: #ffffff;
  border: 1px solid #cccccc;
  width: 50%;
  cursor: pointer;
  text-align: left;
  padding: ${theme.space[1]};
  font-weight: ${theme.fontWeights.semibold};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Filters = styled('div')`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  > div {
    width: auto;
    margin-right: 16px;
    margin-bottom: 0;
    position: relative;
  }
  [data-flight-dropdown-items] {
    position: absolute;
  }

  > h4 {
    font-size: 14px;
    display: flex;
    align-items: center;
    margin-right: 10px;
  }

  svg {
    use {
      fill: black;
    }
  }
`;

const FiltersSectionWrapper = styled('div')`
  display: flex;
  flex-direction: row;
`;

const FiltersWapper = styled('div')`
  width: 100%;
`;
const BoolSortWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 0.875rem;
  > div {
    text-align: right;
    button {
      height: 40px;
      background-color: #f7f7f7;
    }
  }
  [data-flight-dropdown-button] {
    background: none;
    border-radius: 0;
    border: 0;
    &:focus {
      outline: none;
    }
    svg {
      margin-left: 10px;
    }
    &[aria-expanded='true'] .carot {
      transform: rotate(180deg);
    }
  }
  [data-flight-dropdown-items] {
    right: auto;
    left: 0;
    z-index: 3;
    min-width: 250px;
    border: 0 !important;
    background: #f7f7f7;
    top: calc(100% - 1px);

    > li[data-flight-dropdown-item] {
      padding: 0.75em;
      border-top: 1px solid #e8e8e8;
      width: 100%;
      text-align: left;
      background: transparent;
      display: flex;
      align-items: center;
      &:hover,
      &:focus {
        color: black;
        outline: none;
      }
    }
  }
  [data-flight-dropdown-item] {
    display: flex;
    * + * {
      margin-left: auto;
    }
  }
`;

class Filter extends Component {
  render() {
    const { filters } = this.props;
    const sortOrders = get(this, 'props.sortOrders', []);

    return (
      <>
        <Above breakpoint="md">
          {matches =>
            matches && (
              <>
                <FiltersSectionWrapper>
                  <FiltersWapper>
                    <Filters>
                      <h4>Filter:</h4>
                      <ListFilters filters={filters} />
                      <RangeFilters filters={filters} />
                      <BoolSortWrapper>
                        {sortOrders.length > 0 && (
                          <SortOrderDropdown sortOrders={sortOrders} />
                        )}
                        <BooleanFilters filters={filters} />
                      </BoolSortWrapper>
                    </Filters>
                    <Filters>
                      <MultiListFilters filters={filters} />
                    </Filters>
                  </FiltersWapper>
                </FiltersSectionWrapper>
                <ActiveFilters filters={filters} />
              </>
            )
          }
        </Above>
        <Below breakpoint="md">
          {matches =>
            matches && (
              <>
                <ButtonWrapper>
                  <DrawerTrigger id="filterDrawer">
                    {({ showTarget }) => (
                      <MobileButton onClick={showTarget}>
                        <p>{t('Filter')}</p>
                        <Carrot />
                      </MobileButton>
                    )}
                  </DrawerTrigger>

                  {sortOrders.length > 0 && (
                    <DrawerTrigger id="sortDrawer">
                      {({ showTarget }) => (
                        <MobileButton onClick={showTarget}>
                          <p>{t('Sort By')}</p>
                          <Carrot />
                        </MobileButton>
                      )}
                    </DrawerTrigger>
                  )}
                </ButtonWrapper>

                <DrawerTarget id="filterDrawer">
                  {({ hideTarget, isOpen }) => (
                    <Drawer isOpen={isOpen} right>
                      <FilterDrawer close={hideTarget} filters={filters} />
                    </Drawer>
                  )}
                </DrawerTarget>

                {sortOrders.length > 0 && (
                  <DrawerTarget id="sortDrawer">
                    {({ hideTarget, isOpen }) => (
                      <Drawer isOpen={isOpen} right>
                        <FilterDrawer
                          close={hideTarget}
                          sortOrders={sortOrders}
                        />
                      </Drawer>
                    )}
                  </DrawerTarget>
                )}
              </>
            )
          }
        </Below>
      </>
    );
  }
}

export default Filter;
